import { common } from './common.icons';

export const IconGrid4 = ({ className = '', style = {}, ...rest }: any) => {
  return (
    <svg
      fill="currentColor"
      viewBox="0 0 24 21"
      xmlns="http://www.w3.org/2000/svg"
      className={`icon-grid4 ${common.classes} ${className}`}
      {...rest}
      style={{ ...common.styles, ...style }}
    >
      <rect width="4" height="4" transform="translate(0 0.166626)" />
      <rect width="4" height="4" transform="translate(6.66699 0.166626)" />
      <rect width="4" height="4" transform="translate(13.333 0.166626)" />
      <rect width="4" height="4" transform="translate(20 0.166626)" />
      <rect width="4" height="4" transform="translate(0 8.16663)" />
      <rect width="4" height="4" transform="translate(6.66699 8.16663)" />
      <rect width="4" height="4" transform="translate(13.333 8.16663)" />
      <rect width="4" height="4" transform="translate(20 8.16663)" />
      <rect width="4" height="4" transform="translate(0 16.1666)" />
      <rect width="4" height="4" transform="translate(6.66699 16.1666)" />
      <rect width="4" height="4" transform="translate(13.333 16.1666)" />
      <rect width="4" height="4" transform="translate(20 16.1666)" />
    </svg>
  );
};
